import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#FFECF8] border-t border-[#B45092]/10 mt-auto" data-id="element-38">
      <div className="max-w-4xl mx-auto px-6 py-8" data-id="element-39">
        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-6" data-id="element-40">
          <a href="https://www.psiquicos.net/politica_de_privacidad" target="_blank" rel="noopener noreferrer" className="text-sm text-[#121212] hover:text-[#B45092] transition-colors underline" data-id="element-41">
            Política de Privacidad
          </a>
          <span className="text-[#121212]/60" data-id="element-42">•</span>
          <a href="https://www.psiquicos.net/terminos_de_uso" target="_blank" rel="noopener noreferrer" className="text-sm text-[#121212] hover:text-[#B45092] transition-colors underline" data-id="element-43">
            Términos de Uso
          </a>
          <span className="text-[#121212]/60" data-id="element-44">•</span>
          <a href="https://www.facebook.com/PsiquicosMediums" target="_blank" rel="noopener noreferrer" className="text-sm text-[#121212] hover:text-[#B45092] transition-colors underline" data-id="element-45">
            Contacto
          </a>
        </div>

        {/* Affiliate Disclosure */}
        <div className="text-center mb-4" data-id="element-46">
          <p className="text-xs text-[#121212]/70 leading-relaxed max-w-2xl mx-auto" data-id="element-47">
            <strong className="text-[#121212]" data-id="element-48">
              Divulgación de Afiliados:
            </strong>{' '}
            Somos afiliados. Podemos ganar una comisión
            cuando uses nuestros enlaces para visitar su sitio. 
          </p>
        </div>

        {/* Facebook Disclaimer */}
        <div className="text-center" data-id="element-49">
          <p className="text-xs text-[#121212]/70 leading-relaxed max-w-2xl mx-auto" data-id="element-50">
            Este sitio no está afiliado ni respaldado por Facebook (Meta
            Platforms, Inc.). Facebook® es una marca registrada de Facebook,
            Inc. Todas las demás marcas comerciales son propiedad de sus
            respectivos dueños. El contenido y las opiniones expresadas aquí son
            del propietario del sitio y no representan a Facebook.
          </p>
        </div>
      </div>
    </footer>;
}